module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "close pull-left",
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "button",
      "title": "Remove member"
    },
    on: {
      "click": _vm.remove
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "data-toggle": "validator"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Name:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataMember.name),
      expression: "dataMember.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter full name"
    },
    domProps: {
      "value": _vm._s(_vm.dataMember.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataMember.name = $event.target.value
      }
    }
  }), _c('div', {
    staticClass: "help-block with-errors"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Age:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dataMember.age),
      expression: "dataMember.age",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "99",
      "placeholder": "Enter age in years"
    },
    domProps: {
      "value": _vm._s(_vm.dataMember.age)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataMember.age = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "help-block with-errors"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataMember.age === 0),
      expression: "dataMember.age===0"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-4 control-label"
  }, [_vm._v("Age in Months:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.dataMember.month),
      expression: "dataMember.month",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "11",
      "placeholder": "Enter age in months"
    },
    domProps: {
      "value": _vm._s(_vm.dataMember.month)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataMember.month = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _c('div', {
    staticClass: "help-block with-errors"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Sex:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataMember.sex),
      expression: "dataMember.sex"
    }],
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "m"
    },
    domProps: {
      "checked": _vm._q(_vm.dataMember.sex, "m")
    },
    on: {
      "click": function($event) {
        _vm.dataMember.sex = "m"
      }
    }
  }), _vm._v("\n            Male\n          ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataMember.sex),
      expression: "dataMember.sex"
    }],
    attrs: {
      "type": "radio",
      "name": "sex",
      "value": "f"
    },
    domProps: {
      "checked": _vm._q(_vm.dataMember.sex, "f")
    },
    on: {
      "click": function($event) {
        _vm.dataMember.sex = "f"
      }
    }
  }), _vm._v("\n            Female\n          ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataMember.age > 18 && _vm.dataMember.age < 99),
      expression: "dataMember.age>18 && dataMember.age<99"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Work Type:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataMember.work),
      expression: "dataMember.work"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.dataMember.work = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "sedentary"
    }
  }, [_vm._v("Sedentary")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "moderate"
    }
  }, [_vm._v("Moderate")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "heavy"
    }
  }, [_vm._v("Heavy")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.dataMember.age > 18 && _vm.dataMember.age < 50 && _vm.dataMember.sex == 'f'),
      expression: "dataMember.age>18 && dataMember.age<50 && dataMember.sex=='f'"
    }],
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-sm-4"
  }, [_vm._v("Pregnancy Status:")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataMember.state),
      expression: "dataMember.state"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        _vm.dataMember.state = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        })[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "npnl"
    }
  }, [_vm._v("Non-Pregnant, Non-Lactating")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "preg"
    }
  }, [_vm._v("Pregnant")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lact-6"
    }
  }, [_vm._v("Lactating, below 6 months")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lact+6"
    }
  }, [_vm._v("Lactating, above 6 months")])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c6c64856!./~/vue-loader/lib/selector.js?type=template&index=0!./src/member.vue
// module id = 146
// module chunks = 0